<style lang="scss" scoped>
.slide-7 {
  background-image: url("../../../assets/module2/slide7/background-01.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 75px;
  height: calc(100% - 75px);
  padding-left: 140px;
  padding-right: 140px;

  h1 {
    font-size: 60px;
    color: #edad0a;
    text-align: center;
    margin-left: auto;
    width: 1300px;
  }
  h2 {
    transform: rotate(-2deg);
    font-size: 64px;
    color: #3b7fc2;
    margin-top: 25px;
    white-space: nowrap;
    font-size: 60px;
    margin-left: 600px;
    line-height: 35px;
  }
  p {
    color: #1d1d1b;
  }
  .copy {
    width: 400px;
    margin-left: auto;
  }
  .download {
    width: 200px;
    display: block;
    position: absolute;
    left: 58%;
    cursor: pointer;
  }
}
#pdfDocument {
  cursor: pointer;
}
</style>

<template>
  <div class="slide-7">
    <transition name="fadeLeft" appear>
      <img
        class="chars delay-1"
        v-show="slideIndex == 6"
        src="@/assets/module2/slide7/cutouts-01.png"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        class="chars delay-1"
        v-show="slideIndex == 6"
        src="@/assets/module2/slide7/photo-01.png"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 6">
        <h1 class="heading1" v-html="$t('module2.slide7.heading1')"></h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div class="delay-1" v-show="slideIndex == 6">
        <h2 class="heading2">{{ $t("module2.slide7.heading2") }}</h2>
        <h2 class="heading3">{{ $t("module2.slide7.heading3") }}</h2>
      </div>
    </transition>
    <transition name="scale" appear>
      <a
        class="download delay-2"
        v-show="slideIndex == 6"
        :href="pdfLink"
        target="_blank"
      >
        <img src="@/assets/module2/slide7/1x/dowload_print.png" />
      </a>
    </transition>
    <transition name="fadeUp" appear>
      <div class="delay-2 copy" v-show="slideIndex == 6">
        <p>{{ $t("module2.slide7.copy1") }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    slideIndex: { type: Number },
    imageBlob: { type: String, default: "#" },
    imageId: { type: String, default: "0" }
  },
  data: function() {
    return {
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_2_document_1?.url ||
        "../face_masks.pdf"
    };
  },
  methods: {}
};
</script>
